export const NAMESPACE = 'team-management/group-details';

export const GROUP_NAME_FORM_NAME = 'groupNameForm';
export const GROUP_DESCRIPTION_FORM_NAME = 'groupDescriptionForm';
